import React, {useState, useEffect} from "react";
import PropTypes from 'prop-types';
import ProductListed from '../../components/ProductListed';
import ListHead from '../../components/ListHead';
import {scrollTo, byProperty} from '../../lib/utils';
import "./List.css";

export default function List (props) {

  const {items, selected, sortProducts, toggleProducts} = props;
  const [mounted, setMounted] = useState(false);
  const [listed, setListed] = useState([]);
  const [left, setLeft] = useState(0);
  const [step, setStep] = useState(0);
  const [max, setMax] = useState("left");

  const onStep = (dir) => {
    const parent = document.getElementsByClassName("props")[0];
    const div = parent.getElementsByTagName("div")[0];
    const span = div.getElementsByTagName("span")[0];
    const isLast = (div.offsetLeft + div.offsetWidth + 130) < (parent.offsetLeft + parent.offsetWidth);
    //const maxRight = (div.offsetLeft + div.clientWidth) < (parent.offsetLeft + parent.clientWidth);
    //if(!dir || (dir === "right" && !maxRight) || (dir === "left" && step < 0)) {
      const nextStep = dir === "left" ? step + 1 : step - 1;
      const nextLeft = span.clientWidth * nextStep;
      const nextMax = (dir === "right" && isLast) || (dir === "left" && step === -1) ? dir : null;
      setStep(nextStep);
      // for(let i = 0; i < div.getElementsByTagName("span").length; i++){
      //
      //   if(parent.offsetLeft + parent.offsetWidth < div.getElementsByTagName("span")[i].offsetLeft+div.getElementsByTagName("span")[i].offsetWidth){
      //     console.log(div.getElementsByTagName("span")[i].offsetLeft+div.getElementsByTagName("span")[i].offsetWidth - (parent.offsetLeft + parent.offsetWidth));
      //     break;
      //   }
      // }

      setLeft(nextLeft);
      setMax(nextMax);
    //}
  }

  const toggleProp = (key) => {
    const nextListed = listed.map((item, index) => ({...item, collapsed: item.index === key ? !item.collapsed : item.collapsed }));
    setListed(nextListed);
  }

  useEffect(() => {
    if(!mounted){
      setMounted(true);
      scrollTo();
    }
    if(!listed.length){
      const nextListed = !!items[0] ?
        items[0].properties.map((item, index) => (
          {key: item.key, label: item.label, unit: item.unit, collapsed: item.collapsed, index: index})
        ) : [];
      setListed(nextListed);
    }
  }, [mounted, items]);

  return (
    <section className="view list">
      <div>
        <ListHead toggleProp={toggleProp} sort={sortProducts} left={left} items={listed}/>
        <ul>
        {items.map((item, index) =>
          <li key={index}>
            <ProductListed
              data={item}
              listed={listed}
              selected={selected.indexOf(item.id) > -1}
              toggle={toggleProducts}
              toggleProp={toggleProp}
              onStep={onStep}
              left={left}
              max={max}
            />
          </li>
        )}
        </ul>
      </div>
      <small>All properties (except EACN) are measured at T=23° C (liquid emollients). Monadic sensory attributes are evaluated by 10 trained panelist and then classified into four classes.</small>
    </section>
  )
}

ProductListed.propTypes = {
  items: PropTypes.array
};
